<div class="d-flex flex-column container-layout justify-content-between">
    <div class="header d-flex w-100 justify-content-center align-items-center px-4 px-xxl-5" [class.scrolled]="scrolled"
    [class.bg-white]="isReasonPage">
        <app-header class="w-100" [showFooter]="showFooter" [scrolled]="scrolled"></app-header>
    </div>
    <div>
        <router-outlet></router-outlet>
    </div>
    <ng-container *ngIf="showFooter || isResponsive">
        <div class="footer">
            <app-footer class="w-100"></app-footer>
        </div>
    </ng-container>
</div>
<ng-container *ngIf="showLoading">
    <div class="w-100 container-loading">
        <mat-spinner
        class="spinner"
        [diameter]="40"
        [strokeWidth]="4"
        ></mat-spinner>
    </div>
</ng-container>
